import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

export const functionsDB = {
    userAuthentication: function () {
        return new Promise(resolve => {

            // Authetication
            var response = {};
            firebase.auth().onAuthStateChanged(function (user) {
                if (user) {
                    // User is signed in.
                    response.userID = user.uid;
                    var userJson = {
                        displayName: user.displayName,
                        email: user.email,
                        emailVerified: user.emailVerified,
                        photoURL: user.photoURL,
                        providerData: user.providerData,
                        id: user.uid,
                        phoneNumber: user.phoneNumber,
                        creationDate: firebase.firestore.Timestamp.now(),
                        active: true,
                        paySuccess: false,
                        paypalID: "",
                        payUserConfirmation: false,
                        payCancel: false,
                        paySpecial: false,
                        paySpecialType: ""
                    };
                    // Checks if the user exist
                    firebase
                        .firestore()
                        .collection("users")
                        .doc(user.uid)
                        .get()
                        .then(function (doc) {
                            if (doc.exists) {
                                response.loginInfo = "existing user";
                                resolve(response);
                                // self.userRealTime();
                                //console.log("Document existente:", doc.data());
                            } else {
                                // doc.data() will be undefined in this case
                                firebase
                                    .firestore()
                                    .collection("users")
                                    .doc(user.uid)
                                    .set(userJson)
                                    .then(function () {
                                        // console.log("Document successfully written!");
                                        response.loginInfo = "new user";
                                        resolve(response);
                                        //self.userRealTime();
                                    })
                                    .catch(function (error) {
                                        console.error("Error writing document: ", error);
                                        response.loginInfo = "error";
                                        resolve(response);
                                    });
                            }
                        })
                        .catch(function (error) {
                            console.log("Error getting document:", error);
                            response.loginInfo = "error";
                            resolve(response);
                        });
                } else {
                    response.loginInfo = "signed out";
                    resolve(response);
                    // User is signed out.
                }
            });

        });
    },
    writeNewForm: function (collection, userID, formJSON) {
        formJSON.creationTT = firebase.firestore.Timestamp.now();
        return new Promise(resolve => {
            firebase
                .firestore()
                .collection(collection)
                .doc(userID)
                .collection("forms")
                .add(formJSON)
                .then(function () {
                    resolve("yes")
                })
                .catch(function (error) {
                    console.log(error);
                    resolve("error")
                });
        });
    },
    deleteForm: function (collection, userID, formID) {
        return new Promise(resolve => {
            firebase
                .firestore()
                .collection(collection)
                .doc(userID)
                .collection("forms")
                .doc(formID)
                .delete()
                .then(function () {
                    resolve(true)
                })
                .catch(function (error) {
                    resolve(false)
                });
        });
    },
    saveInputs: function (collection, userID, formID, arrayInputs) {
        return new Promise(resolve => {
            firebase
                .firestore()
                .collection(collection)
                .doc(userID)
                .collection("forms")
                .doc(formID)
                .update({
                    inputs: arrayInputs
                })
                .then(function () {
                    resolve(true)
                })
                .catch(function (error) {
                    resolve(false)
                });
        });
    },
    getGuardForms: function (collection, userID) {
        var forms = [];
        var state;
        return new Promise(resolve => {
            firebase
                .firestore()
                .collection(collection)
                .doc(userID)
                .collection("forms")
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        var tempDoc = doc.data();
                        tempDoc.id = doc.id;
                        // doc.data() is never undefined for query doc snapshots
                        forms.push(tempDoc);
                    });
                    resolve(forms);
                })
                .catch(function (error) {
                    console.log("Error getting documents: ", error);
                    state = false;
                    resolve(null);
                });
        });
    },
    writeNewRecord: function (collection, userID, record) {
        return new Promise(resolve => {
            firebase
                .firestore()
                .collection(collection)
                .doc(userID)
                .collection("records")
                .add(record)
                .then(function () {
                    resolve(true)
                })
                .catch(function (error) {
                    console.log(error);
                    resolve(false)
                });
        });
    },
    updateRecord: function (collection, userID, recordID, newContent) {
        return new Promise(resolve => {
            firebase
                .firestore()
                .collection(collection)
                .doc(userID)
                .collection("records")
                .doc(recordID)
                .update(newContent)
                .then(function () {
                    resolve(true)
                })
                .catch(function (error) {
                    console.log(error);
                    resolve(false)
                });
        });
    }

};